
import { useNavigate } from "react-router-dom";
import { Plus, Lightbulb, Users, Briefcase } from "lucide-react";

interface ServiceGroup {
  title: string;
  icon: JSX.Element;
  items: Array<{
    label: string;
    route: string;
  }>;
}

interface HowToWorkWithMeProps {
  services: ServiceGroup[];
}

export const HowToWorkWithMe = ({
  services
}: HowToWorkWithMeProps) => {
  const navigate = useNavigate();

  const handleServiceClick = (route: string) => {
    // Store current scroll position
    const scrollPosition = window.scrollY;
    sessionStorage.setItem('scrollPosition', scrollPosition.toString());

    // Navigate to the route and scroll to top
    navigate(route);
    window.scrollTo(0, 0);
  };

  return <>
      <div className="flex items-end">
        <h2 className="text-[40px] leading-[0.95] font-groteks font-medium md:text-6xl">
          HOW YOU CAN WORK WITH ME
        </h2>
      </div>
      
      <div className="mt-14 space-y-4">
        {services.map(group => group.items.map((item, itemIndex) => (
          <button 
            key={itemIndex} 
            className="w-full text-left px-10 py-[34px] bg-white border-2 border-black rounded-[32px] hover:bg-gray-50 transition-colors duration-200 flex items-center gap-2 group" 
            onClick={() => handleServiceClick(item.route)}
          >
            <Plus className="w-10 h-10" />
            <span className="text-[38px] leading-[1.16] font-medium">
              {item.label}
            </span>
            <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-2xl">
              →
            </span>
          </button>
        )))}
      </div>
    </>;
};
